import React from 'react'
import UpdateForm from '../../../forms/update/UpdateForm'
import { useParams } from 'react-router-dom'

const EditForm = () => {
    const {id}=useParams()
  
    return (
        <div className="w-full flex flex-col px-10 pb-10">
        <div className="branch_header">
          <div className="branch_header_title_group">
            <div className="branch_header_title_main">Edit Form</div>
        
          </div>
        </div>
        <UpdateForm id={id} />
        </div>
    )
}

export default EditForm
